import {createSelector} from 'reselect';

import type {NutshellState} from '../../store';

import {getUIState} from '../ui-selectors';

const getCreatorState = createSelector([getUIState], (uiState) => uiState.creator);

export const getFlashMessages = (state: NutshellState) => getCreatorState(state).flashMessages;
